<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div class="flex justify-content-between" role="toolbar">
        <div class="flex">
          <div>
            <i class="pi pi-users title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">{{'menu.users' | transloco}}</p>
            <p>
              {{(mode == 'create' ? 'misc.creation.user' : 'misc.edition.user') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <ng-container *ngIf="!isUserLoading && userForm">
        <form *ngIf="userForm" [formGroup]="userForm">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="firstName">{{'attribute.firstName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="firstName" id="firstName" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('firstName')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="lastName">{{'attribute.lastName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="lastName" id="lastName" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('lastName')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="username">{{'attribute.username' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="username" id="username" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('username')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <input class="w-full" formControlName="email" id="email" pInputText type="text">
              </div>
              <app-validation-errors [control]="userForm.get('email')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="phone">{{'attribute.phone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <ngx-intl-tel-input [cssClass]="'w-full'" [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                  [searchCountryPlaceholder]="'search.byCountry' | transloco" [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="true"
                  [separateDialCode]="true" [maxLength]="15" [phoneValidation]="true" [inputId]="'phone'"
                  [numberFormat]="PhoneNumberFormat.International" formControlName="phone" id="phone">
                </ngx-intl-tel-input>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="profile">{{'model.profile' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown [placeholder]="'select.profile' | transloco" [options]="profiles" [filter]="true" [showClear]="true"
                  filterBy="name" styleClass="w-full" optionLabel="name" optionValue="profileUuid" id="profile"
                  formControlName="profile"></p-dropdown>
              </div>
              <app-validation-errors [control]="userForm.get('profile')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.language' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown [options]="languageOptions" [(ngModel)]="selectedLanguage"
                  [ngModelOptions]="{standalone: true}" optionLabel="name" filterBy="name"
                  styleClass="w-full dropdown-language">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + selectedLanguage.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{selectedLanguage.name}}</p>
                    </div>
                  </ng-template>
                  <ng-template let-language pTemplate="item">
                    <div class="flex align-items-center">
                      <i [class]="'flag-icon flag-icon-' + language.code"></i>
                      <p class="mb-0 ml-1 mt-1 p-0">{{language.name}}</p>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="timeZone">{{'attribute.timezone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-dropdown
                  [placeholder]="'select.timezone' | transloco"
                  [options]="timeZoneOptions"
                  [filter]="true"
                  styleClass="w-full"
                  id="timeZone"
                  optionValue="name"
                  optionLabel="name"
                  formControlName="timeZone"
                ></p-dropdown>
              </div>
              <app-validation-errors [control]="userForm.get('timeZone')"></app-validation-errors>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organization">{{'model.organization' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-treeSelect [(ngModel)]="selectedOrganization" [placeholder]="'select.organization' | transloco"
                  [options]="hierarchy" [ngModelOptions]="{standalone: true}" id="organization"
                  [disabled]="userFromOtherHierarchy"></p-treeSelect>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div *ngIf="mode === 'edit'" class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="eCommerceUser">{{'attribute.eCommerceUser' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-checkbox id="eCommerceUser" formControlName="eCommerceUser" binary="true" class="w-full" [disabled]="true"></p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="enabled">{{'attribute.enabled' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-checkbox id="enabled" formControlName="enabled" binary="true" class="w-full"></p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="blocked">{{'attribute.limitedAccess' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-checkbox id="blocked" formControlName="blocked" binary="true" class="w-full"></p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="emailVerified">{{'attribute.emailVerified' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-checkbox id="emailVerified" formControlName="emailVerified" binary="true" class="w-full">
                </p-checkbox>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.requieredActions' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-multiSelect [options]="requiredUserActions" formControlName="requieredActions" optionLabel="name"
                               optionValue="code" display="chip" styleClass="w-full" [placeholder]="'select.action' | transloco"></p-multiSelect>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="password">{{'attribute.password' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-password [toggleMask]="true" (change)="newPasswordCheck()"
                  styleClass="p-password p-component p-input-icon-right w-full-password" class="w-full" id="password"
                  formControlName="password"></p-password>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="confirmPassword">{{'attribute.repeatPassword' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-password [toggleMask]="true" (change)="newPasswordCheck()"
                  styleClass="p-password p-component p-input-icon-right w-full-password" class="w-full"
                  id="confirmPassword" formControlName="confirmPassword"></p-password>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>&nbsp;</label>
              </div>
              <div class="col-12">
                <button [label]="'common.generatePassword' | transloco" (click)="generatePassword()" pButton
                  class="p-button-secondary" icon="pi pi-key"></button>
              </div>
            </div>
          </div>
        </form>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <button [label]="'common.cancel' | transloco" [routerLink]="'/users'" pButton class="p-button-danger"
                  iconPos="right"></button>
                <p-button [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
                          [disabled]="!userForm?.valid || !selectedOrganization" [loading]="persistingChanges"
                          (onClick)="persistUserData()" styleClass="p-button-primary"></p-button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isUserLoading || userForm == null">
        <div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="firstName">{{'attribute.firstName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="lastName">{{'attribute.lastName' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="username">{{'attribute.username' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="email">{{'attribute.email' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="phone">{{'attribute.phone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="profile">{{'model.profile' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.language' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="timeZone">{{'attribute.timezone' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="organization">{{'model.organization' | transloco}}: (*)</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="eCommerceUser">{{'attribute.eCommerceUser' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="enabled">{{'attribute.enabled' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="blocked">{{'attribute.limitedAccess' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="emailVerified">{{'attribute.emailVerified' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="1.5rem" height="1.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>{{'attribute.requieredActions' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
          </div>
          <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="password">{{'attribute.password' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label for="confirmPassword">{{'attribute.repeatPassword' | transloco}}:</label>
              </div>
              <div class="col-12">
                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
              </div>
            </div>
            <div class="col-12 md:col-12 lg:col-6 xl:col-4">
              <div class="form-field col-12">
                <label>&nbsp;</label>
              </div>
              <div class="col-12">
                <div class="w-15rem">
                  <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12">
            <div class="mt-auto col-12">
              <div class="flex justify-content-between mt-4">
                <div class="w-8rem">
                  <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                </div>
                <div class="w-8rem">
                  <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
